var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "com-skill-label flex align-items-center" },
    [
      _c(
        "yxt-checkbox",
        {
          attrs: { indeterminate: _vm.disabled, disabled: _vm.disabled },
          model: {
            value: _vm.skillModel.checked,
            callback: function ($$v) {
              _vm.$set(_vm.skillModel, "checked", $$v)
            },
            expression: "skillModel.checked",
          },
        },
        [
          _c(
            "yxt-popover",
            {
              attrs: {
                placement: "bottom",
                "max-width": 500,
                trigger: "hover",
              },
            },
            [
              _vm.skillLevel
                ? _c("div", { staticClass: "skill-popover-ctx" }, [
                    _c("div", { staticClass: "mb8" }, [
                      _vm._v(
                        _vm._s(
                          "" +
                            _vm
                              .$t("pc_biz_training_legend_standard")
                              .d("标准") +
                            _vm.skillLevel.name
                        ) + "："
                      ),
                    ]),
                    _vm.skillModel.skill.description
                      ? _c("div", [
                          _vm._v(
                            _vm._s(
                              " " +
                                _vm
                                  .$t("pc_biz_global_lbl_skillDescription")
                                  .d("能力描述") +
                                "：" +
                                _vm.skillModel.skill.description
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.skillLevel.behavior
                      ? _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$t("pc_biz_lbl_level_performance")
                                .d("等级行为表现") +
                                "：" +
                                _vm.skillLevel.behavior
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.skillLevel.description
                      ? _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$t("pc_biz_global_lbl_levelDescription")
                                .d("等级描述") +
                                "：" +
                                _vm.skillLevel.description
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "skill-popover-ctx" }, [
                    _vm.skillModel.skill.description
                      ? _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$t("pc_biz_global_lbl_skillDescription")
                                .d("能力描述") +
                                "：" +
                                _vm.skillModel.skill.description
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
              _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
                _c("div", { staticClass: "max-w120 ellipsis" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.skillModel.name) + "\n        "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }